import { throttle } from 'lodash-es';

import logger from '../../services/logging/logging-service';
import { isArticlePage, isLiveBlogPage, isEntertainmentDomain, isTg24Domain } from '../../utils/aem-utils';
import { isInjectedHPInView, isInjectedHP } from '../../utils/injected-hp-utils';
import { isMobile, isNativeLazyLoadingSupported } from '../../utils/device-utils';
import { satelliteTracker } from '../../services/tracking/satellite-tracking-service';
import { changeUrlAndHistory } from '../../utils/change-url';
import { initPlayers } from '../video-player/init-players';
import { initDatalayerElement, addDatalayerAttrs } from '../tracking/datalayer';
// import { initLazyContentLoader } from '../async/lazy-content-loader';
import { removeElementDom, prepareImagesForNativeLazyLoading } from '../../utils/dom-utils';
import { dynamicTrackingOnURLChange } from '../../services/tracking/parsely-tracking-service';
import { skyFoundationSettings } from '../../services/configs/configs-service';
import { SITE_DOMAINS } from '../../utils/constants';
import { PARSELY_TOP_NEWS } from '../../utils/csr-anchors';
import { showPrimaryHideLocal, hidePrimaryShowLocalWithoutTitle } from '../primary-tag/primary-tag';
import { initPathbreakerSlider } from '../pathbreaker/pathbreaker';
import {
  asyncAdvTopBottom,
  asyncParselyMyLocalNews,
  asyncParselyMySport,
  asyncParselyMyTeam,
  asyncSlimBannerHPSport,
  asyncSlimBannerHPTg24,
  asyncLatestNews,
} from '../async/async-component-importer';
import { commonActions } from '../../global-store/subjects/common';

import { initParselyRenderRailMostViewd } from './parsely-render-rail-most-viewd';
import { initParselyRender } from './parsely-render';

const WRAPPER_PAGE = '.j-wrapper';
const LOCAL_NAV = '.j-local-nav';
const GLOBAL_NAV = '.j-global-nav';
const HP_TABS = '.j-hp-tabs';
const HP_MULTIVIDEO = '.j-video-in-evidenza';
const FOOTER = '.j-footer';
const DTMOBJ = '.j-digital-data';
const OBSERVER_ELEMENT = 'injected-homepage j-injected-homepage';
const TV_CARD = '.j-tv-card';
const RAIL_MOBILE_TOP = '.c-rail-content';
const RAIL_MOBILE_BOTTOM = '#parselyTopNewsHP';

const hidePlayer = document.querySelector('.j-player-card__close');
let stickyVideoToClick = true;

const SATELLITE_CHANGE_TRACK = 'change_template';
const SCROLL_EVENT_TROTTLE_TIME = 1000;
let dtmSettings = window.digitalData;
let hasSkinInPage = true;
let enablePageIntersection = false;
let appendHomePage = true;
let isInitHomepageADV = true;
let isParselyInitialized = false;
let currentViewportWidth = window.innerWidth;
let targetPoint;
let targetObserver;

const PARSELY_TOP_NEWS_HP_ID = 'parselyTopNewsHP';
const PARSELY_SET_OF_CARDS_HP_ID = 'parselySetOfCardsHP';

const articleTitle = document.title;
const homepageTitle = skyFoundationSettings.getTitleHomepage();

const NAV_HEIGHT = 60;

const onlyLive = true;

/**
 * Article to HomePage in article and viceversa "video in spalla" variables for video player switch
 */
const railLiveContainer = document.querySelector('.j-player-live-container');
const railLiveSettings = document.querySelector('.j-player-live-container .j-player')
  ? document.querySelector('.j-player-live-container .j-player').outerHTML
  : null;
let hpInArticleRailLiveContainer;
let hpInArticleRailLiveSettings;

/**
 * Compute HP Url
 */
const getHomePageURL = () => {
  return isEntertainmentDomain() ? `${window.location.origin}/${SITE_DOMAINS.ENTERTAINMENT}` : window.location.origin;
};

/**
 * Check if is HP in article enabled or not
 */
const isHomepageInArticle = skyFoundationSettings.getLazyLoadedHomepage();

/**
 * Remove ADV Skin
 */
const removeSkinADV = () => {
  if (!isMobile()) {
    const SKIN = document.querySelector('#adSkinDiv');
    const SKINBACKGROUND = document.querySelector('#adSkinDivBg');
    const SKINOFFSET = document.querySelector('#adSkinDivOffset');
    const SKINTOP = document.querySelector('#adSkinDivTop');
    const SKINLEFT = document.querySelector('#adSkinDivLeft');
    const SKINRIGHT = document.querySelector('#adSkinDivRight');
    const SKINIMAGE = document.querySelector('#adSkinDivImg');
    const ArraySkinADV = [SKIN, SKINBACKGROUND, SKINOFFSET, SKINTOP, SKINLEFT, SKINRIGHT, SKINIMAGE].filter(Boolean);
    ArraySkinADV.forEach((element) => removeElementDom(element));
  }
};

/**
 * Change DTM fot tracking
 * @param {*} param DTM params
 */
const changeDTM = (param) => {
  if (typeof param === 'string') {
    const paramToDTM = param.split('=');
    window.digitalData = JSON.parse(paramToDTM[1]);
    logger.info('change DTM for Inject hp in ARTICLE PAGE, homepage');
  } else {
    window.digitalData = param;
    logger.info('change DTM for Inject hp in ARTICLE PAGE, article');
  }
  logger.info(window.digitalData);
  addDatalayerAttrs();
};

/**
 * Run observer for HP
 * @param {*} hpHtmlSelectedDTM dtm to update
 * @param {*} hpURL homepage URL
 */
const runObserve = (hpHtmlSelectedDTM, hpURL) => {
  const currentPageURL = window.location.href;
  dtmSettings = window.digitalData;
  hpInArticleRailLiveContainer =
    document.querySelectorAll('.j-player-live-container').length > 1
      ? document.querySelectorAll('.j-player-live-container')[1]
      : null;
  logger.info(`currentPageURL: ${currentPageURL}, dtmSettings: ${dtmSettings}`);

  const callback = (entries) => {
    entries.forEach((entry) => {
      logger.info(`---- targetPoint: ${targetPoint}, entry.intersectionRect.height: ${entry.intersectionRect.height}`);
      if (entry.intersectionRect.height > targetPoint && !isInjectedHPInView()) {
        // function change DTM and URL with observer
        if (!isInjectedHP()) {
          commonActions.setInjectedHP(true);
        }
        commonActions.setInjectedHPInView(true);
        if (homepageTitle) {
          document.title = homepageTitle;
        }
        if (!isParselyInitialized) {
          isParselyInitialized = true;
          asyncSlimBannerHPSport();
          asyncSlimBannerHPTg24();
          asyncParselyMyTeam(); // Trigger even if this widget is hidden (on mobile), in order to set the global store for the slim banner HP,
          asyncParselyMySport(); // Trigger even if this widget is hidden (on mobile), in order to set the global store for the slim banner HP,
          asyncParselyMyLocalNews(); // Trigger even if this widget is hidden (on mobile), in order to set the global store for the slim banner HP,
          asyncLatestNews();
          if (!isMobile()) {
            logger.info('init PARSELY RAILS ');
            if (document.getElementById(PARSELY_TOP_NEWS_HP_ID)) {
              initParselyRender(PARSELY_TOP_NEWS_HP_ID, PARSELY_SET_OF_CARDS_HP_ID);
            }
            initParselyRenderRailMostViewd();
          }
        }
        changeDTM(hpHtmlSelectedDTM);
        changeUrlAndHistory(hpURL);
        satelliteTracker.trackInWeb(SATELLITE_CHANGE_TRACK);
        logger.info('change track for Inject hp in ARTICLE PAGE is INTERSECTING');
        dynamicTrackingOnURLChange(hpURL, currentPageURL);
        hidePrimaryShowLocalWithoutTitle();
        logger.info('--- Call hidePrimaryShowLocalWithoutTitle() primary --- articolo -> HP ---');
        if (hidePlayer && stickyVideoToClick) {
          hidePlayer.click();
          stickyVideoToClick = false;
        }
        if (hasSkinInPage) {
          removeSkinADV();
          hasSkinInPage = false;
        }
        if (isInitHomepageADV) {
          asyncAdvTopBottom();
          isInitHomepageADV = false;
        }
        if (!enablePageIntersection) {
          enablePageIntersection = true;
        }

        if (isTg24Domain()) {
          /**
           * hpInArticleRailLiveContainer checks if there are two rail player (one in article and one in hp) and gets the second.
           * If there are two player it means that the article player it's not collapsed.
           * initPlayer must runs because it takes care of collapse the hp rail player
           */
          if (hpInArticleRailLiveContainer) {
            railLiveContainer.innerHTML = '';
            hpInArticleRailLiveContainer.innerHTML = hpInArticleRailLiveSettings;
          }
          initPlayers(onlyLive);
        }
        // pathbreakerSlider intialize slider dots
        initPathbreakerSlider();
      }
      if (entry.intersectionRect.height < targetPoint && enablePageIntersection && isInjectedHPInView()) {
        commonActions.setInjectedHPInView(false);
        document.title = articleTitle;
        changeDTM(dtmSettings);
        changeUrlAndHistory(currentPageURL);
        satelliteTracker.trackInWeb(SATELLITE_CHANGE_TRACK);
        logger.info('change track for Inject hp in ARTICLE PAGE is NOT-INTERSECTING');
        dynamicTrackingOnURLChange(currentPageURL, hpURL);
        showPrimaryHideLocal();
        logger.info('--- Call showPrimaryHideLocal() primary --- HP -> articolo ---');

        if (isTg24Domain()) {
          if (railLiveContainer) {
            hpInArticleRailLiveContainer.innerHTML = '';
            railLiveContainer.innerHTML = railLiveSettings;
            initPlayers(onlyLive);
          }
        }
      }
    });
  };

  targetObserver = document.getElementsByClassName(OBSERVER_ELEMENT)[0];

  const getTargetPoint = () => {
    const abstractHpElement = document
      .getElementsByClassName(OBSERVER_ELEMENT)[0]
      .querySelectorAll('.c-hero__content,.ftbl__c-hero__content')[0];
    const abstractBottomToHpTopDistance =
      abstractHpElement.parentElement.offsetTop + abstractHpElement.offsetHeight + abstractHpElement.offsetTop;
    const viewportWithoutNav = window.innerHeight - NAV_HEIGHT;
    /** in landscape mobile viewport height is smaller than abstractBottomToHpTopDistance,
     *  in this case when the observed element fills the viewport the observer stops to launch entries.
     *  The value of intersectRect.height equals the viewport height but it's never larger.
     *  To avoid this targetPoint switchs to viewportWithoutNav.
     */
    const targetPointCalc =
      window.innerHeight < abstractBottomToHpTopDistance ? viewportWithoutNav : abstractBottomToHpTopDistance;

    return targetPointCalc;
  };

  targetPoint = getTargetPoint();

  window.addEventListener(
    'resize',
    throttle(() => {
      logger.info(window.innerWidth !== currentViewportWidth);
      if (window.innerWidth !== currentViewportWidth) {
        targetPoint = getTargetPoint();
        currentViewportWidth = window.innerWidth;
      }
    }, SCROLL_EVENT_TROTTLE_TIME)
  );

  /** "i" represents the entire target element (in Sport mobile the element is ~20k px tall, desktop is 10k px tall)
   *  because we want to trigger the observer only inside the initial part of the element,
   *  "i" is divided by 15 (now the triggering area is between 1300 and 600px)
   *  then "i" is divided by the numSteps value that indicate the subdivisions of target element portion
   */
  const buildThresholdList = () => {
    const thresholds = [];
    const numSteps = 40;
    for (let i = 1.0; i <= numSteps; i++) {
      const ratio = i / 15 / numSteps;
      thresholds.push(ratio);
    }
    thresholds.push(0);
    return thresholds;
  };

  // rootMargin doesn't work well on Samsung Internet browser
  const observerOptions = {
    // rootMargin: `0px 0px -${abstractBottomToHpTopDistance}px 0px`,
    threshold: buildThresholdList(),
  };

  const observer = new IntersectionObserver(callback, observerOptions);
  if (targetObserver) {
    observer.observe(targetObserver);
  }
};
/** it's not possible use removeElementDom utility because it checks if the element is a DOM element
 *  and we need to remove HTML elements inside an HTMLElement that it's not already a DOM element.
 *  Also you can move the remove function after the HTMLElement became a DOM element but you need to redo query selections.
 */
const removeElements = ($fromElement, selectors) => {
  selectors.forEach((selector) => {
    const $element = $fromElement.querySelector(selector);
    if ($element) {
      removeElementDom($element);
    }
  });
  logger.info('complete get html from url and transform in element selected + remove unnecessary elements');
};
/**
 * Inject HP in Article
 * @param {*} hpSelectedHTML
 */
const injectHP = (hpSelectedHTML) => {
  const footerElement = document.querySelector(FOOTER);
  // const footerElementsToRemove = [FOOTER_SECTION_CONTAINER, FOOTER_DISCLAIMER];
  const hpHtmlWrapper = document.createElement('div');
  const customDividerTemplate = `
    <div class="c-footer__variant">
      <span class="c-footer__variant-label">
        <i class="icon icon--social icon--medium icon--left-aligned-m">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 994 994" class="icon__svg icon__svg--facebook-messenger" fill="currentColor" width="80" height="80"><linearGradient id="aaa" gradientUnits="userSpaceOnUse" x1="497" y1="1003" x2="497" y2="9.013" gradientTransform="matrix(1 0 0 -1 0 1003)"><stop offset="0" stop-color="#00b2ff"/><stop offset="1" stop-color="#006aff"/></linearGradient><path d="M497 0C217 0 0 205.1 0 482.1 0 627 59.4 752.2 156.1 838.7c8.1 7.3 13 17.4 13.4 28.3l2.7 88.4c.9 28.2 30 46.5 55.8 35.2l98.6-43.5c8.4-3.7 17.7-4.4 26.5-2 45.3 12.5 93.6 19.1 143.9 19.1 280 0 497-205.1 497-482.1S777 0 497 0z" fill-rule="evenodd" clip-rule="evenodd" fill="url(#aaa)"/><path d="M198.6 623.1l146-231.6c23.2-36.8 73-46 107.8-19.9l116.1 87.1c10.7 8 25.3 7.9 35.9-.1l156.8-119c20.9-15.9 48.3 9.2 34.2 31.4L649.5 602.5c-23.2 36.8-73 46-107.8 19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9.1L232.8 654.5c-20.9 15.9-48.3-9.2-34.2-31.4z" fill-rule="evenodd" clip-rule="evenodd" fill="#fff"/></svg>
        </i>
        Le news di Sky Sport su Facebook Messenger:
      </span>
      <a class="c-cta c-cta--primary" href="https://sport.sky.it/messenger">
        <span class="c-cta__text">Iscriviti </span>
        <i class="icon icon--arrow-navigation icon--arrow-link icon--c-primary">
          <svg class="icon__svg icon__svg--arrow-link" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="80" height="80">
            <path d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </i>
      </a>
    </div>
  `;

  // removeElement(footerElement, footerElementsToRemove);
  footerElement.classList.add('c-footer--default', 'c-footer--hp-divider');
  if (!footerElement.classList.contains('c-footer--default')) {
    footerElement.querySelector('.c-footer__logo').insertAdjacentHTML('afterend', customDividerTemplate);
  }
  hpHtmlWrapper.className = OBSERVER_ELEMENT;
  hpHtmlWrapper.innerHTML = hpSelectedHTML.outerHTML;
  if (isNativeLazyLoadingSupported()) {
    prepareImagesForNativeLazyLoading(hpHtmlWrapper);
  }
  footerElement.insertAdjacentElement('afterend', hpHtmlWrapper);
};

/**
 * Change IDs of parsely node DOM
 * @param {*} hpHtml
 */
const manageParselyNodeDoms = (hpHtmlSelected) => {
  if (!isMobile()) {
    const parselyTopNews = hpHtmlSelected.querySelector(PARSELY_TOP_NEWS);
    const parselyTopNewsElementToHydrate = hpHtmlSelected.querySelector('#parselySetOfCards');
    if (parselyTopNews && parselyTopNewsElementToHydrate) {
      parselyTopNews.id = PARSELY_TOP_NEWS_HP_ID;
      parselyTopNewsElementToHydrate.id = PARSELY_SET_OF_CARDS_HP_ID;
      parselyTopNewsElementToHydrate.setAttribute('id', PARSELY_SET_OF_CARDS_HP_ID);
      parselyTopNews.setAttribute('id', PARSELY_TOP_NEWS_HP_ID);
    }
  }
};

/**
 * Prepare all images in selected HTML for images native lazy loading
 * @param {*} hpHtmlSelected
 */
const prepareImagesForLazyLoading = (hpHtmlSelected) => {
  if (isNativeLazyLoadingSupported()) {
    const images = hpHtmlSelected.querySelectorAll('img[loading="lazy"][data-src]');
    images.forEach((img) => {
      img.src = img.getAttribute('data-src');
      img.srcset = img.getAttribute('data-src');
    });
  }
};

const parseStringToDom = (htmlString) => {
  const dom = new DOMParser().parseFromString(htmlString, 'text/html');
  dom.querySelectorAll('style').forEach((e) => e.remove());
  return dom;
};

/**
 * take html(in text) from url
 */
const httpGetHomepage = async (theUrl, customHeaders = {}) => {
  logger.info('the html of the page is START');
  logger.info(customHeaders);
  const httpParameters = { method: 'GET', headers: customHeaders };
  const response = await fetch(theUrl, httpParameters);
  const htmlString = await response.text();
  const hpDOM = parseStringToDom(htmlString);
  return hpDOM;
};

/**
 * Homepage Observer
 * @param {*} hpURL homepage URL
 */
const addObserverHP = async (hpURL) => {
  if (appendHomePage) {
    appendHomePage = false;
    // eslint-disable-next-line no-use-before-define
    window.removeEventListener('scroll', throttleObserveLauncher);
    let removingElements;
    if (isMobile()) {
      if (isEntertainmentDomain()) {
        removingElements = [LOCAL_NAV, GLOBAL_NAV, HP_TABS, HP_MULTIVIDEO, RAIL_MOBILE_TOP, RAIL_MOBILE_BOTTOM];
      } else {
        removingElements = [
          LOCAL_NAV,
          GLOBAL_NAV,
          HP_TABS,
          HP_MULTIVIDEO,
          TV_CARD,
          RAIL_MOBILE_TOP,
          RAIL_MOBILE_BOTTOM,
        ];
      }
    } else {
      removingElements = [LOCAL_NAV, GLOBAL_NAV, HP_TABS, HP_MULTIVIDEO];
    }
    const customHeaders = new Headers({
      'Content-Type': 'text/plain',
      'lazy-loaded': isHomepageInArticle,
    });
    const hpHtml = await httpGetHomepage(hpURL, customHeaders);
    if (hpHtml) {
      const hpHtmlSelectedDTM = hpHtml.querySelector(DTMOBJ).innerHTML;
      const hpHtmlSelected = hpHtml.querySelector(WRAPPER_PAGE);
      manageParselyNodeDoms(hpHtmlSelected);
      prepareImagesForLazyLoading(hpHtmlSelected);
      injectHP(hpHtmlSelected);

      // Store Homepage in article "video in spalla" configurations
      hpInArticleRailLiveSettings = hpHtmlSelected.querySelector('.j-player-live-container .j-player')
        ? hpHtmlSelected.querySelector('.j-player-live-container .j-player').outerHTML
        : null;

      const HP_INJECT = document.querySelector('.j-injected-homepage');
      removeElements(HP_INJECT, removingElements);
      runObserve(hpHtmlSelectedDTM, hpURL);
      initDatalayerElement();
    }
  } else {
    logger.info('Hp already appended');
  }
};
/**
 * Trottoling on Observer Laucher
 */
const throttleObserveLauncher = throttle(() => {
  addObserverHP(getHomePageURL());
}, SCROLL_EVENT_TROTTLE_TIME);
/**
 * Render Homepage
 */
const initRenderHp = () => {
  if (isHomepageInArticle && (isArticlePage() || isLiveBlogPage())) {
    window.addEventListener('scroll', throttleObserveLauncher);
  }
};

export { initRenderHp };
